export const settingsName = "settings"
